import { Types } from './types'

const initialState = {
    dataNews: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const NewsReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_NEWS:
            return {
                ...newState,
                dataNews: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return { ...newState }
    }
}
export default NewsReducer
